export default {
  FETCH_DASHBOARDS_REQUEST: 'FETCH_DASHBOARDS_REQUEST',
  FETCH_DASHBOARDS_SUCCESS: 'FETCH_DASHBOARDS_SUCCESS',
  FETCH_DASHBOARDS_FAILURE: 'FETCH_DASHBOARDS_FAILURE'
}
